<template>
  <div id="app">
    <router-view />
    <rf-footer />
  </div>
</template>

<script>
import RfFooter from '@/components/RfFooter'

export default {
  name: 'App',
  data () {
    return {
    }
  },
  beforeMount () {
    this.$store.dispatch('getPages')
    this.$store.dispatch('getPosts')
    this.$store.dispatch('getTags')
  },
  computed: {
  },
  components: { RfFooter }
}
</script>

<style>
body {
  margin: 0px;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  overflow: hidden;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue